var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceDetail',{attrs:{"resource-override":"cloudcredential","parent-route-override":"c-cluster-manager-cloudCredential"}})
}
var staticRenderFns = []

export { render, staticRenderFns }